import React from 'react';
import { connect } from 'react-redux';

import { CheckParameter } from '../../../../../utils/security';

const PersonInfo = ({ label, name, doc, isEmployee }) => {
  const employeeLabel = isEmployee === 1 ? 'Empleado' : 'Externo';
  const employeeClass = isEmployee === 1 ? 'text-green-600' : 'text-red-600';

  return (
    <div className="flex flex-col gap-0.5 rounded border border-gray-200 bg-gray-50 p-1.5 text-xs">
      <div className="flex items-center gap-1.5">
        <span className="font-semibold text-gray-700">{label}:</span>
        <span
          className="truncate font-medium"
          title={name}>
          {name || 'Sin nombre'}
        </span>
      </div>
      <div className="text-[11px] text-gray-600">Doc: {doc || 'N/D'}</div>
      <div className={`text-[11px] font-medium ${employeeClass}`}>{employeeLabel}</div>
    </div>
  );
};

const TbodyTableManifiesto = (props) => {
  const row = props.Solicitud.selSolicitud;
  const rowTipoVehiculo = props.tipoVehiculo.selTipoVehiculo;

  return (
    <tbody className="bg-white text-gray-700">
      <tr className="border-b border-gray-200 hover:bg-gray-50">
        <td className="whitespace-nowrap px-3 py-2 text-left">
          <div className="flex flex-col gap-0.5">
            <span className="font-medium">{row?.SOLICITUD_CONSECUTIVO_INT}</span>
            <span className="text-xs text-gray-600">
              {getReporteTrabajo(row)}
              {getPrefactura(row)}
            </span>
            <span className="text-[11px] text-gray-500">{row?.SOLICITUD_FECHA}</span>
          </div>
        </td>
        <td className="px-3 py-2 text-left text-sm">{row?.SOLICITUD_CONSECUTIVO}</td>
        {CheckParameter(props.auth?.data.selCliente.parametro, 'PARAMETRO_ID', 2) && <td className="px-3 py-2 text-left text-sm">{row?.SOLICITA}</td>}
        <td className="px-3 py-2 text-left text-sm">{row?.SOLICITUD_DESCRIPCION}</td>

        <td className="px-3 py-2 text-left">
          <div className="flex flex-col gap-0.5">
            <span className="text-sm font-medium">{row?.unidad_negocio[0]?.NEGOCIO_NOMBRE}</span>
            <span className="text-xs font-semibold text-blue-600">Estado: {row?.SOLICITUD_ESTADO_DESCRIPCION}</span>
          </div>
        </td>
        <td className="px-3 py-2 text-left">
          <div className="flex flex-col gap-2">
            {/* Tipo de Vehículo */}
            {rowTipoVehiculo && (
              <div
                className="flex flex-col gap-1"
                key={rowTipoVehiculo.SOLICITUD_VEHICULO_TIPO_ID}>
                <div className="flex flex-wrap items-center gap-1.5 text-sm">
                  <span className="font-medium text-gray-800">{rowTipoVehiculo.VEHICULO_TIPO_DESCRIPCION}</span>
                  <span className="rounded bg-green-100 px-1.5 py-0.5 text-xs font-semibold text-green-700">{rowTipoVehiculo.VEHICULO_PLACA}</span>
                  <span
                    className={`rounded px-1.5 py-0.5 text-xs font-semibold ${
                      rowTipoVehiculo.V_VEHICULO_PROPIO === 1 ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                    }`}>
                    {rowTipoVehiculo.V_VEHICULO_PROPIO === 1 ? 'Propio' : 'Externo'}
                  </span>
                </div>
                {rowTipoVehiculo.V_VEHICULO_PROPIO === 0 && (
                  <div className="text-[11px] text-gray-600">
                    <strong>
                      {rowTipoVehiculo.V_TERCERO_TENEDOR_NOMBRE || 'Sin tenedor'} - {rowTipoVehiculo.V_TERCERO_TENEDOR_DOCUMENTO || 'N/D'}
                    </strong>
                  </div>
                )}
              </div>
            )}
            {/* Personal (Conductor y Aparejador) */}
            <div className="flex flex-col gap-1.5 border-t border-gray-200 pt-1.5">
              {(rowTipoVehiculo?.CONDUCTOR_DOC || rowTipoVehiculo?.CONDUCTOR_IDENTIFICACION) && (
                <PersonInfo
                  label="Conductor"
                  name={rowTipoVehiculo?.CONDUCTOR_NOMBRE}
                  doc={rowTipoVehiculo?.CONDUCTOR_DOC || rowTipoVehiculo?.CONDUCTOR_IDENTIFICACION}
                  isEmployee={rowTipoVehiculo?.CONDUCTOR_ES_EMPLEADO}
                />
              )}
              {(rowTipoVehiculo?.APAREJADOR_DOC || rowTipoVehiculo?.APAREJADOR_IDENTIFICACION) && rowTipoVehiculo?.APAREJADOR_NOMBRE && (
                <PersonInfo
                  label="Aparejador"
                  name={rowTipoVehiculo?.APAREJADOR_NOMBRE}
                  doc={rowTipoVehiculo?.APAREJADOR_DOC || rowTipoVehiculo?.APAREJADOR_IDENTIFICACION}
                  isEmployee={rowTipoVehiculo?.APAREJADOR_ES_EMPLEADO}
                />
              )}
            </div>
          </div>
        </td>

        <td className="px-3 py-2 text-left text-sm">
          <div className="flex max-w-[240px] flex-col">
            <span
              className="truncate font-medium"
              title={row?.ORIGEN}>
              {row?.ORIGEN}
            </span>
            <span
              className="flex items-center gap-2 truncate text-xs text-gray-600"
              title={row?.DESTINO}>
              <span className="text-gray-400">→</span>
              <span className="truncate">{row?.DESTINO}</span>
            </span>
          </div>
        </td>
      </tr>
    </tbody>
  );
};

const mapStateToProps = function (state) {
  return {
    Solicitud: state.Solicitud,
    tipoVehiculo: state.tipoVehiculo,
  };
};

const getReporteTrabajo = (row) => {
  if (Number(row.ORDEN_OPERACION_CONSECUTIVO) > 0) {
    return ` (${row.ORDEN_OPERACION_CONSECUTIVO})`;
  }
  return '';
};
const getPrefactura = (row) => {
  if (Number(row.PREFACTURA_CONSECUTIVO) > 0) {
    return ` (${row.PREFACTURA_CONSECUTIVO})`;
  }
  return '';
};

//export default Projects;
export default connect(mapStateToProps)(TbodyTableManifiesto);
